import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import loginImg from "../assets/images/loginImg.png";
import Button from "../components/utils/Button";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import authactions from "../redux/auth/actions";
import ToastAlert from "../components/utils/ToastAlert";
import QRCode from "react-qr-code";

const { login, verifyOtp, resetMessage, forgotPassword } = authactions;

const Login = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const {
    loginLoading,
    loginData,
    loginMessage,
    loginError,
    verifyOtpresult,
    verifyOtpLoading,
    verifyOtpMessage,
    verifyOtpError,
    forgotPasswordLoading,
    forgotPasswordMessage,
    forgotPasswordError
  } = useSelector((state) => state.auth);
  const [activeCard, setActiveCard] = useState(1);
  const [seconds, setSeconds] = useState(30);
  const [isActive, setIsActive] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const {
    register: otpregister,
    handleSubmit: otphandleSubmit,
    reset: otpReset,
    formState: { errors: otperrors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      otpCode: "",
    },
  });

  const {
    register: forgotPwRegister,
    handleSubmit: forgotPwhandleSubmit,
    reset: forgotPwReset,
    formState: { errors: forgotPwErrors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      username: "",
    },
  });

  useEffect(() => {
    if (loginMessage && Object.keys(loginData).length > 0) {
      setActiveCard(2);
      setIsActive(true);
      setSeconds(30);
    }
    if (loginError) {
      ToastAlert({ type: "error", text: loginError });
    }
  }, [loginData, loginMessage, loginError]);

  useEffect(() => {
    if (forgotPasswordMessage) {
      ToastAlert({ type: "success", text: forgotPasswordMessage });
      setActiveCard(1);
    }
    if (forgotPasswordError) {
      ToastAlert({ type: "error", text: forgotPasswordError });
    }
  }, [forgotPasswordError, forgotPasswordMessage]);

  useEffect(() => {
    if (verifyOtpMessage) {
      ToastAlert({ type: "success", text: verifyOtpMessage });
      setTimeout(() => {
        localStorage.setItem("colt_wireless_token", verifyOtpresult?.token);
        window.location.href = "/";
      }, 500);
    }

    if (verifyOtpError) {
      ToastAlert({ type: "error", text: verifyOtpError });
    }
  }, [verifyOtpMessage, verifyOtpError]);

  const onSubmit = (data) => {
    dispatch(resetMessage());
    otpReset();
    dispatch(login(data));
  };

  const onForgotPassword = (data) => {
    dispatch(forgotPassword(data))
  };

  const onOtpSubmit = (otpData) => {
    dispatch(resetMessage());
    otpData.userName = loginData?.userName;
    dispatch(verifyOtp(otpData));
  };

  const onBack = () => {
    setActiveCard(1);
    dispatch(resetMessage());
    otpReset();
  };

  useEffect(() => {
    let interval = null;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(true);
      setSeconds(30);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive, seconds]);

  function FeatureRow({ icon, iconBg, title, text }) {
    return (
      <div className="d-flex align-items-start mb-3 feature-row">
        <div className={`feature-icon ${iconBg} me-3`}>
          <i className={`bi ${icon}`} />
        </div>
        <div>
          <div className="feature-title">{title}</div>
          <div className="feature-text">{text}</div>
        </div>
      </div>
    );
  }


  return (
    <div className="login-page d-flex align-items-center justify-content-center py-3 px-3">
      <div className="login-card shadow-sm">
        <div className="row g-0">
          {/* LEFT PANEL */}
          <div
            className="col-lg-6 login-left d-none d-lg-flex flex-column justify-content-center px-5 pt-4"
            style={{ minHeight: "88vh" }}
          >
            <div>
              <h1 className="welcome-title mb-3">Welcome!</h1>
              <p className="welcome-subtitle">
                Login to your account and continue to manage your SIM
                activations.
              </p>

              <div
                className="my-4"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img src={loginImg} alt="logo" />
              </div>
            </div>
          </div>

          {/* RIGHT PANEL - FORM */}
          <div className="col-lg-6 login-right p-4 p-md-5 d-flex align-items-center">
            {activeCard == 1 && (
              <form
                className="w-100 login-form"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
              >
                <div className="text-center mb-4">
                  <h2 className="login-title mb-2">Sign In</h2>
                  <p className="login-subtitle mb-0">
                    Enter your credentials to access your account.
                  </p>
                </div>

                {/* User ID */}
                <div className="mb-3">
                  <label htmlFor="username" className="form-label fw-semibold">
                    UserName <span className="text-danger">*</span>
                  </label>
                  <div
                    className={`input-icon-group ${errors.username ? "is-invalid-group" : ""}`}
                  >
                    <input
                      id="username"
                      type="text"
                      placeholder="Enter Username"
                      className={`form-control custom-input ${errors.username ? "is-invalid" : ""
                        }`}
                      {...register("username", {
                        required: "Username is required",
                      })}
                    />
                  </div>
                  {errors?.username && (
                    <div className="invalid-feedback d-block">
                      {" "}
                      {errors?.username?.message}{" "}
                    </div>
                  )}
                </div>

                {/* Password */}
                <div className="mb-2">
                  <label htmlFor="password" className="form-label fw-semibold">
                    Password <span className="text-danger">*</span>
                  </label>
                  <div
                    className={`input-icon-group ${errors.password ? "is-invalid-group" : ""
                      }`}
                  >
                    <div className="input-group">
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter password"
                        className={`form-control custom-input ${errors.password ? "is-invalid" : ""
                          }`}
                        {...register("password", {
                          required: "Password is required",
                        })}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() => setShowPassword((pre) => !pre)}
                        style={{
                          backgroundColor: "var(--bg-content)",
                          borderColor: "var(--border-color)",
                          color: "var(--hedging-text-color)",
                          cursor: "pointer",
                        }}
                      >
                        <i
                          className={
                            showPassword ? "ri-eye-off-line" : "ri-eye-line"
                          }
                          style={{ fontSize: "18px" }}
                        />
                      </span>
                    </div>
                  </div>
                  {errors.password && (
                    <div className="invalid-feedback d-block">
                      {" "}
                      {errors.password.message}{" "}
                    </div>
                  )}
                </div>

                <div className="text-end mb-3">
                  <span
                    className="forgot-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      reset({
                        username: "",
                        password: "",
                      });
                      dispatch(resetMessage());
                      setActiveCard(3);
                    }}
                  >
                    Forgot Password?
                  </span>
                  {/* <a href="#forgot-password" className="forgot-link"> Forgot Password? </a> */}
                </div>

                <div className="d-grid mt-4">
                  <Button
                    title="Sign In"
                    buttonType="submit"
                    icon={
                      <i className="ri-login-circle-line me-2 align-middle" />
                    }
                    variant="primary"
                    loading={loginLoading}
                    disable={loginLoading ? true : false}
                    style={{ padding: "10px 20px" }}
                  />
                </div>

                {/* <Link
                  to="/"
                  className="btn btn-outline-primary mt-4 w-100"
                  style={{ padding: "10px 20px" }}
                >
                  <i className="ri-user-star-line me-2"></i>Become a Dealer
                </Link> */}
              </form>
            )}
            {activeCard == 2 && (
              <div className="w-100 login-form" noValidate>

                {!loginData?.ismfAenable ? <>
                  <div className="text-center mb-4">
                    <h2 className="login-title mb-2">
                      Two-Factor Authentication
                    </h2>
                    <p className="login-subtitle mb-0">
                      Scan the QR code below using Microsoft Authenticator or
                      Authy, then enter the 6-digit code.
                    </p>
                  </div>

                  {/* QR Code */}
                  <div
                    className="my-4"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="p-3"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        borderRadius: "15px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                      }}
                    >
                      <QRCode value={loginData?.qrCodeImage} size={165} />
                    </div>
                  </div>
                </> : <>
                  <div className="text-center mb-4">
                    <h2 className="login-title mb-2">
                      Multi-Factor Authentication
                    </h2>
                    <p className="login-subtitle mb-0">
                      Enter the 6-digit verification code from your Microsoft
                      Authenticator or Authy app to continue.
                    </p>
                  </div>

                </>}

                <form onSubmit={otphandleSubmit(onOtpSubmit)}>
                  {/* Password */}
                  <div className="mb-2">
                    <label
                      htmlFor="password"
                      className="form-label fw-semibold"
                    >
                      OTP Code<span className="text-danger">*</span>
                    </label>
                    <div
                      className={`input-icon-group ${otperrors.otp ? "is-invalid-group" : ""
                        }`}
                    >
                      <div className="input-group">
                        <input
                          id="otpCode"
                          type="tel"
                          placeholder="Enter 6-digit code"
                          className={`form-control custom-input ${otperrors.otpCode ? "is-invalid" : ""
                            }`}
                          {...otpregister("otpCode", {
                            required: "OTP is required",
                            pattern: {
                              value: /^[0-9]{6}$/,
                              message: "OTP must be exactly 6 digits",
                            },
                          })}
                        />
                      </div>
                    </div>
                    {otperrors.otpCode && (
                      <div className="invalid-feedback d-block">
                        {" "}
                        {otperrors?.otpCode?.message}{" "}
                      </div>
                    )}
                  </div>

                  <div className="d-grid mt-4">
                    <Button
                      title="Verify OTP"
                      buttonType="submit"
                      icon={
                        <i className="ri-shield-check-line me-2 align-middle" />
                      }
                      variant="primary"
                      loading={verifyOtpLoading}
                      disable={verifyOtpLoading ? true : false}
                      style={{ padding: "10px 20px" }}
                    />
                  </div>

                  <div className="text-center mt-2">
                    <span
                      onClick={() => onBack()}
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        cursor: "pointer",
                        color: "#8e0f9d",
                        fontWeight: "500",
                      }}
                    >
                      <i className="ri-arrow-left-long-line fs-5 mt-1"></i>
                      Back{" "}
                    </span>
                  </div>
                </form>
              </div>
            )}

            {activeCard == 3 && (
              <form
                className="w-100 login-form"
                onSubmit={forgotPwhandleSubmit(onForgotPassword)}
                noValidate
              >
                <div className="text-center mb-4">
                  <h2 className="login-title mb-2">Forgot Password</h2>
                  <p className="login-subtitle mb-0">
                    Enter your username and we'll send your password to your registered email address.
                  </p>
                </div>

                {/* User ID */}
                <div className="mb-3">
                  <label htmlFor="username" className="form-label fw-semibold">
                    Username <span className="text-danger">*</span>
                  </label>
                  <div
                    className={`input-icon-group ${forgotPwErrors.username ? "is-invalid-group" : ""}`}
                  >
                    <input
                      id="username"
                      type="text"
                      placeholder="Enter Username"
                      className={`form-control custom-input ${forgotPwErrors.username ? "is-invalid" : ""
                        }`}
                      {...forgotPwRegister("username", {
                        required: "Username is required",
                      })}
                    />
                  </div>
                  {forgotPwErrors?.username && (
                    <div className="invalid-feedback d-block">
                      {" "}
                      {forgotPwErrors?.username?.message}{" "}
                    </div>
                  )}
                </div>

                <div className="d-grid mt-4">
                  <Button
                    title="Send Password"
                    buttonType="submit"
                    icon={
                      <i className="ri-rotate-lock-line fs-5 me-2 align-middle" />
                    }
                    variant="primary"
                    loading={forgotPasswordLoading}
                    disable={forgotPasswordLoading ? true : false}
                    style={{ padding: forgotPasswordLoading ? "12px 20px" : "6px 20px" }}
                  />
                </div>
                <div className="text-center mt-2">
                  <span
                    onClick={() => {
                      forgotPwReset();
                      dispatch(resetMessage());
                      setActiveCard(1);
                    }}
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      cursor: "pointer",
                      color: "#8e0f9d",
                      fontWeight: "500",
                    }}
                  >
                    <i className="ri-arrow-left-long-line fs-5 mt-1"></i>
                    Back{" "}
                  </span>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
